import Vue from 'vue';

import { VueEasyJwt } from 'vue-easy-jwt';
import VueRouter from 'vue-router';

import EquipmentDepartureSheet from '@/components/tickets/equipments-departure/EquipmentDepartureSheet.vue';
import { CustomerManagement, PasswordRecovery } from '@/components/users';
import { contactsRouter } from '@/modules/contacts/shared/router/contacts-router';
import { equipmentsRouter } from '@/modules/equipments/router/equipments-router';
import { feedbacksRouter } from '@/modules/feedbacks/router/feedbacks-router';
import { infodaycoRouter } from '@/modules/infodayco/shared/router/infodayco.router';
import BillsView from '@/modules/invoicing/views/BillsView.vue';
import UploadInvoice from '@/modules/invoicing/views/UploadInvoice.vue';
import { reportsRouter } from '@/modules/reports/shared/router/reports-router';
import Layout from '@/modules/shared/layouts/components/Layout.vue';
import Portal from '@/modules/shared/shared/views/Portal.vue';
import { ticketsRouter } from '@/modules/tickets/shared/router/tickets-router';
import Login from '@/modules/users/views/Login.vue';
import ability from '@/plugins/acl/ability';

import { PDT, TapeDeliveryReceptionSheet } from '../../../../components/tickets';

const jwt = new VueEasyJwt();

Vue.use(VueRouter);

const routes = [
    {
        path: '/layout',
        name: 'layout',
        component: Layout,
    },
    {
        path: '/portal',
        name: 'portal',
        component: Portal,
        children: [
            ...feedbacksRouter,
            ...reportsRouter,
            ...equipmentsRouter,
            ...ticketsRouter,
            ...contactsRouter,
            ...infodaycoRouter,
            {
                path: 'finances',
                name: 'finances',
                component: BillsView,
            },
            {
                path: 'dayco-customers',
                name: 'dayco-customers',
                component: CustomerManagement,
                props: true,
            },
            {
                path: 'dayco-finances',
                name: 'dayco-finances',
                component: UploadInvoice,
            },
        ],
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/',
        name: 'base',
        component: Login,
    },
    {
        path: '/pdt',
        name: 'pdt',
        component: PDT,
    },
    {
        path: '/equipment-sheet',
        name: 'equipment-sheet',
        component: EquipmentDepartureSheet,
        props: true,
    },
    {
        path: '/tape-delivery-reception',
        name: 'tape-delivery-reception',
        component: TapeDeliveryReceptionSheet,
    },
    {
        path: '/password-recovery',
        name: 'password-recovery',
        component: PasswordRecovery,
        query: { reset_token: '' },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    to.matched.some(route => {
        if (route.meta.requiresAuth) {
            const yourToken: any = localStorage.getItem('token');
            if (jwt.isExpired(yourToken)) {
                localStorage.clear();
                next({ path: '/login' });
            } else {
                if (to.meta && to.meta.privilege) {
                    if (ability.can(to.meta.privilege.action, to.meta.privilege.resource)) {
                        next();
                    } else {
                        next('/');
                    }
                } else {
                    next();
                }
            }
        } else {
            next();
        }
    });
});

export default router;
